<template>
	<div class="tabWrapper wrapMyInformation">
		<no-info
				v-if="contacts && inventory && documents
				&& contacts.length <= 0 && inventory.length <= 0 && documents.length <= 0"
				text="The information is not filled in, please fill in the user information"
		/>
		<div v-else class="main">
			<!-- userInfo -->
			<div class="itemInformation userInfo" v-if="contacts && contacts.length > 0">
				<div class="head">
					<item-info-row
							icon-id="user"
							:is-item-text="false"
							:is-item-dashed="false"
							value="My contacts"
							is-big-value
							is-flex-start
							custom-class="userName"
					/>
				</div>

				<div
						class="rowWrap"
						v-for="(item, index) in getListExtension"
						:key="uniqKey(index)"
				>
					<item-info-row
							icon-id="Phone"
							:text="getExtensionText(item)"
							:value="getExtensionValue(item)"
							isClickValue
							@updateClickValue="onCopyToClipboard(item.value)"
					/>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(item.value)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39'}"
						/>
					</div>
				</div>

				<div
						class="rowWrap"
						v-for="(item, index) in getListMessengers"
						:key="uniqKey(index)"
				>
					<item-info-row
							:icon-id="item.icon"
							:text="item.name"
							:value="item.value"
							isClickIcon
							isClickValue
							@updateClickIcon="onOpenMessengers(item)"
							@updateClickValue="onCopyToClipboard(item.value)"
					/>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(item.value)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39'}"
						/>
					</div>
				</div>
			</div>

			<!-- inventory -->
			<div class="itemInformation inventory" v-if="inventory && inventory.length > 0">
				<item-info-row
						icon-id="icon-Inventory"
						:is-item-text="false"
						:is-item-dashed="false"
						value="My inventory"
						is-big-value
						is-flex-start
						custom-class="userName"
				/>
				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeaders"
						:listItems="inventory"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="500"
						:pages="[10, 20, 50, 100, 200, 500, 'All']"
						:is-pagination="false"
				/>
			</div>

			<!-- document -->
			<div class="itemInformation document" v-if="documentsList && documentsList.length > 0">
				<item-info-row
						icon-id="icon-document"
						:is-item-text="false"
						:is-item-dashed="false"
						value="My documents"
						is-big-value
						is-flex-start
						custom-class="userName"
				/>
				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeadersDocumentsList"
						:listItems="documentsList"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="500"
						:pages="[10, 20, 50, 100, 200, 500, 'All']"
						:is-pagination="false"
				/>
			</div>

			<!-- Payment account information -->
			<div class="itemInformation userInfo" v-if="hasPaymentAccount">
				<div class="head">
					<item-info-row
							icon-id="MoneyReceive"
							:is-item-text="false"
							:is-item-dashed="false"
							value="Payment account information"
							is-big-value
							is-flex-start
							custom-class="userName"
					/>
				</div>

				<div class="rowWrap" v-if="pAcc.account_name">
					<item-info-row icon-id="folderUser" text="Account name" :value="pAcc.account_name"/>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.account_name)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39'}"
						/>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="folderUser"
							text="Account name"
					></item-info-row>
				</div>

				<div class="rowWrap" v-if="pAcc.address">
					<item-info-row icon-id="cardUser" text="Address" :value="pAcc.address"/>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.address)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39'}"
						/>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="cardUser"
							text="Address"
					></item-info-row>
				</div>

				<div class="rowWrap" v-if="pAcc.iban">
					<item-info-row icon-id="money-check-dollar" text="IBAN" :value="pAcc.iban"/>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.iban)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39'}"
						/>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="money-check-dollar	"
							text="IBAN"
					></item-info-row>
				</div>

				<div class="rowWrap" v-if="pAcc.swift">
					<item-info-row icon-id="money-check-dollar" text="SWIFT" :value="pAcc.swift"/>
					<div class="btnWrapper">
						<icon-btn
								@updateEvent="onCopyToClipboard(pAcc.swift)"
								custom-class="infoBTN"
								:icon-attrs="{iconId: 'icon-copy', width: 20, height: 20, color: '#1dab39'}"
						/>
					</div>
				</div>
				<div class="rowWrap" v-else>
					<item-info-row
							icon-color="var(--base-orange)"
							icon-id="money-check-dollar	"
							text="SWIFT"
					></item-info-row>
				</div>

			</div>
		</div>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		/>
		<preview-doc
				v-if="linkPreviewDoc"
				@clear-link="clearLinkPreviewDoc"
				:link-doc="linkPreviewDoc"
				:file-name="fileName"
		/>
	</div>
</template>

<script>
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import IconBtn from "@/pages/Account/IconBtn/iconBtn.vue";
import { mapActions, mapGetters } from "vuex";
import checkStringTelegramUserName from "@/helper/checkStringTelegramUserName";
import getUniqId from "@/helper/getUniqId";
import MainTable from "@/shared/MainTable/MainTable.vue";
import { accountTableInventory, accountTableDocuments } from "@/pages/Account/constants";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import PreviewDoc from "@/modules/invoices/preview.vue";
import { getAppUrl } from "@/services";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";

export default {
	name: "AccountTabMyInformation",
	components: { NoInfo, PreviewDoc, DialogRemove, IconBtn, ItemInfoRow, MainTable },
	computed: {
		...mapGetters([ "myInformation" ]),
		getHeaders() {
			return accountTableInventory; 
		},
		getHeadersDocumentsList() {
			return accountTableDocuments; 
		},
		getListExtension() {
			return Array.isArray(this.contacts)
				? this.contacts.filter(i => i && i.extension !== null)
				: [];
		},
		getListMessengers() {
			return Array.isArray(this.contacts)
				? this.contacts.filter(i => i && i.extension === null)
				: [];
		},
		hasPaymentAccount() {
			const p = this.payment_account || {};
			const s = v => typeof v === "string" && v.length > 0;
			return s(p.iban) || s(p.account_name) || s(p.swift) || s(p.address);
		},
		pAcc() {
			const p = this.payment_account || {};
			return {
				iban: p.iban || "",
				account_name: p.account_name || "",
				swift: p.swift || "",
				address: p.address || "",
			};
		},
	},
	data: () => ({
		inventory: [],
		contacts: [],
		contactsTypes: null,
		payment_account: {},

		activeItem: null,
		activeDelete: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		documents: null,
		documentsTypes: null,
		documentsList: null,

		linkPreviewDoc: null,
		fileName: null,

		flag: "AccountTabSalaryHistory",
	}),
	methods: {
		...mapActions([ "setAlert", "deleteExtensionMyInformation", "getMyInformation" ]),
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null; 
		},
		onClickButton({ key, item }) {
			if (key === "view") {
				const { document_path } = item;
				this.linkPreviewDoc = getAppUrl + document_path;
				this.fileName = document_path.split("/").pop();
			}
		},
		uniqKey(id) {
			return getUniqId() + id; 
		},
		onCopyToClipboard(text) {
			navigator.clipboard.writeText(text).then(() => {
				this.setAlert({ type: "success", message: `Successfully copied to clipboard [ <b>${ text }</b> ]` });
			}).catch(err => {
				console.error("Could not copy text: ", err);
				this.setAlert({ type: "error", message: "Whoops, something went wrong! 🙁" });
			});
		},
		getExtensionValue(item) {
			return `${ item.value }`; 
		},
		getExtensionText(item) {
			return `${ item.extension }:`; 
		},
		onOpenMessengers(item) {
			const { type, value } = item;
			if (type === "Telegram") {
				const userName = checkStringTelegramUserName(value);
				window.open(`https://t.me/${ userName }`, "_blank");
			}
			if (type === "Whatsapp") {
				window.open(`https://wa.me/${ value }`, "_blank");
			}
			if (type === "Viber") {
				window.open(`viber://chat?number=${ value }`, "_blank");
			}
			if (type === "Mobile") {
				window.open(`tel:${ value }`, "_blank");
			}
			if (type === "Email") {
				window.open(`mailto:${ value }`, "_blank");
			}
		},
		async onRemove() {
			if (this.activeDelete === "extension") {
				const { id } = this.activeItem;
				await this.deleteExtensionMyInformation(id);
			} else if (this.activeDelete === "messenger") {
				const { id } = this.activeItem;
				await this.deleteMessengerMyInformation(id);
			}
			this.onCloseRemove();
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false; 
		},
	},
	async mounted() {
		await this.getMyInformation();
		const { inventory, contacts, documents, documentsTypes, payment_account } = this.myInformation;
		this.inventory = inventory;
		this.contacts = contacts;
		this.documents = documents;
		this.documentsTypes = documentsTypes;
		this.payment_account = payment_account;

		if (documents && documents.length > 0) {
			const types = Array.isArray(documentsTypes) ? documentsTypes : [];
			this.documentsList = documents.map(doc => {
				const docType = types.find(t => t && t.id === doc.type_id);
				return { ...doc, type_name: docType ? docType.name : null };
			});
		}
	},
};
</script>

<style scoped lang="scss">
@import "AccountTabMyInformation";
</style>

<style lang="scss">
.wrapMyInformation {
	.main {
		.itemInformation {
			overflow: auto;
			&.document,
			&.inventory {
				.pageList--wrap {
					.pagination {
						padding: 20px 0 0 0 !important;
					}
				}
			}
		}
	}
}
</style>
